// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class File {
  readonly id: string;
  readonly storageKey: string;
  readonly fileName: string;
  readonly contentType: string;
  readonly sizeBytes: number;
  readonly uploadedBy: string;
  readonly isSensitive: boolean;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;
  readonly archivedAt: DateTime | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.storageKey = data.storageKey === undefined ? '' : data.storageKey;
    this.fileName = data.fileName === undefined ? '' : data.fileName;
    this.contentType = data.contentType === undefined ? '' : data.contentType;
    this.sizeBytes = data.sizeBytes === undefined ? 0 : data.sizeBytes;
    this.uploadedBy = data.uploadedBy === undefined ? NIL_UUID : data.uploadedBy;
    this.isSensitive = data.isSensitive === undefined ? false : data.isSensitive;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
    this.archivedAt = DateHelpers.ParseServerNullableDate(data.archivedAt);
  }

  static zero(): File {
    const zeroValues: ExcludeMethodsDeep<File> = {
      id: NIL_UUID,
      storageKey: '',
      fileName: '',
      contentType: '',
      sizeBytes: 0,
      uploadedBy: NIL_UUID,
      isSensitive: false,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      archivedAt: null,
    };
    return new File(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type FileWireFormat = {
  id: string;
  storageKey: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  uploadedBy: string;
  isSensitive: boolean;
  createdAt: string;
  updatedAt: string;
  archivedAt: string | null;
};

type NewFileProps = PartialDeep<File, { recurseIntoArrays: true }>;
export const NewFile: (props: NewFileProps) => File = (props) => new File(props);

type NewFileFromWireFormatProps = PartialDeep<FileWireFormat, { recurseIntoArrays: true }>;
export const NewFileFromWireFormat: (props: NewFileFromWireFormatProps) => File = (props) =>
  new File(props);
